import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import { SearchMalls, SearchMallsVariables } from "./types/SearchMalls";

export const searchMalls = gql`
  ${pageInfoFragment}
  query SearchMalls(
    $after: String
    $brandId: ID
    $first: Int!
    $query: String!
    $filterStatus: String
    $status: SmopStatusEnum
    $sortBy: MallSortingInput
    $userMalls: Boolean
    $isServiceable: Boolean
  ) {
    search: malls(
      after: $after
      first: $first
      filter: {
        search: $query
        brand: $brandId
        status: $filterStatus
        userMalls: $userMalls
        isServiceable: $isServiceable
      }
      status: $status
      sortBy: $sortBy
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchMalls, SearchMallsVariables>(
  searchMalls
);
